module.exports = __webpack_public_path__ + "img/logoin.8469b10a.png";